import {
  GET_FUND_TRANSFERS_SUCCESS,
  GET_REALTIME_BALANCES_SUCCESS,
  FUND_TRANSFER_LOADING,
  FUND_TRANSFER_ERROR
} from '../Actions/FundTransferAction';

const initialState = {
  transfers: [],
  realtimeBalances: {
    summary: {
      totalAvailableGlobal: 0,
      totalGlobalCoins: 0,
      totalGlobalBills: 0,
      totalPendingInTransit: 0,
      totalInConversion: 0,
      totalConverted: 0
    },
    locations: [],
    sourceStats: {}
  },
  loading: false,
  error: null
};

const FundTransferReducer = (state = initialState, action) => {
  switch (action.type) {
    case FUND_TRANSFER_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_FUND_TRANSFERS_SUCCESS:
      return {
        ...state,
        transfers: action.payload,
        loading: false,
        error: null
      };

    case GET_REALTIME_BALANCES_SUCCESS:
      return {
        ...state,
        realtimeBalances: action.payload,
        loading: false
      };

    case FUND_TRANSFER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default FundTransferReducer;
